










































import Vue from 'vue'
import Component from 'vue-class-component'

import {
  projectVariables,
  socialMediaVariables,
  customMessages
} from '../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { WEB_PAGE_INFORMATION_LIST } from '../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

@Component({
  filters: {
    caplocks (value: string) {
      if (!value) return ''
      return value.toUpperCase()
    }
  }
})
class Footer1 extends Vue {

  projectName: string = projectVariables.projectName
  companyPoweredByCompanyImageIconUrl: string = projectVariables.companyPoweredByCompanyImageIconUrl

  digitalCurrencySymbolImageIconUrl: string = projectVariables.digitalCurrencySymbolImageIconUrl
  digitalCurrencyAcceptedHereImageUrl: string = projectVariables.digitalCurrencyAcceptedHereImageUrl

  gitlabSocialMedia = socialMediaVariables.gitlab
  youtubeSocialMedia = socialMediaVariables.youtube
  twitterSocialMedia = socialMediaVariables.twitter

  websitePageInformationList = WEB_PAGE_INFORMATION_LIST

  thankYouForJoiningUniversalBasicIncome: string = customMessages.thankYouForJoiningUniversalBasicIncome

  updateText (text: string): string {
    let newText = text.replace('{{projectName}}', this.projectName || '')

    return newText
  }
}

export default Footer1
